
import * as angular from 'angular';

class DiscountForStaffHistoryTab {}

angular.module('naut').component('discountForStaffHistoryTab', {
    template: require('./discount-for-staff-history-tab.component.html'),
    controller: DiscountForStaffHistoryTab,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/discountForStaff/history-tab/discount-for-staff-history-tab.component.ts